<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="算法" prop="taskType">
              <a-input placeholder="请输入算法" v-model="model.taskType"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="摄像头名称" prop="cameraName">
              <a-input placeholder="请输入摄像头名称" v-model="model.cameraName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="可信度" prop="score">
              <a-input-number placeholder="请输入可信度" style="width: 100%" v-model="model.score" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="告警级别" prop="alertLevel">
              <j-dict-select-tag
                dictCode="alert_level"
                placeholder="请选择告警级别"
                type="radioButton"
                v-model="model.alertLevel"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="锁闭时间(分)" prop="lockMin">
              <a-input-number placeholder="请输入锁闭时间(分)" style="width: 100%" v-model="model.lockMin" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用" prop="enabled">
              <j-dict-select-tag dictCode="yn" placeholder="请选择是否启用" type="radioButton" v-model="model.enabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="消息推送" prop="alertPushId">
              <j-multi-select-tag
                dictCode="`iwt-wf`.iot_alert_push,name,id"
                placeholder="请选择消息推送"
                type="list_multi"
                v-model="model.alertPushId"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EdgeboardTasktypeConfigForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          taskType: [
            { required: true, message: '请输入算法!' },
          ],
          cameraName: [
            { required: true, message: '请输入摄像头名称!' },
          ],
          alertLevel: [
            { required: true, message: '请选择告警级别!' },
          ],
          score: [
            { required: false },
            { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!' },
          ],
          lockMin: [
            { required: false },
            { pattern: /^-?\d+$/, message: '请输入整数!' },
          ],
        },
        url: {
          add: "/alert/edgeboardTasktypeConfig/add",
          edit: "/alert/edgeboardTasktypeConfig/edit",
          queryById: "/alert/edgeboardTasktypeConfig/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>